export enum PriceFormat {
  FULL = 'full',
  PARTIAL = 'partial'
}
